import React from 'react';
import { connect } from 'react-redux';
import Paper from '@material-ui/core/Paper';
import Title from '../components/Title';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import { withStyles } from '@material-ui/core/styles';
import NumberFormat from 'react-number-format';

const styles = theme => ({
    paper: {
        padding: theme.spacing(2),
        margin: theme.spacing(2),
    },
    totalRow: {
        fontWeight: 'bold',
    },
});

const AccountHoldings = (props) => {
  const { account_id, classes } = props;

  return (
    <div>
        {props.account_holdings && props.account_holdings.length > 0 &&
        <React.Fragment>
            <Paper className={classes.paper}>
                <Title>Account Holdings</Title>
                    <Table size="small">
                    <TableHead>
                        <TableCell>Name</TableCell>
                        <TableCell>Price Per Share</TableCell>
                        <TableCell>Cost Basis Per Share</TableCell>
                        <TableCell>Quantity</TableCell>
                        <TableCell>Total Value</TableCell>
                        <TableCell>Total Cost Basis</TableCell>
                    </TableHead>
                    <TableBody>
                        {props.account_holdings.map(holding => (
                            <TableRow key={holding.holding_id}>
                                <TableCell>{holding.holding_name}</TableCell>
                                <TableCell><NumberFormat value={holding.price} displayType={'text'} thousandSeparator={true} prefix={'$'} decimalScale={2} fixedDecimalScale={true} /></TableCell>
                                <TableCell><NumberFormat value={holding.cost_basis} displayType={'text'} thousandSeparator={true} prefix={'$'} decimalScale={2} fixedDecimalScale={true} /></TableCell>
                                <TableCell><NumberFormat value={holding.quantity} displayType={'text'} thousandSeparator={true} decimalScale={2} fixedDecimalScale={true} /></TableCell>
                                <TableCell><NumberFormat value={holding.value} displayType={'text'} thousandSeparator={true} prefix={'$'} decimalScale={2} fixedDecimalScale={true} /></TableCell>
                                <TableCell><NumberFormat value={holding.total_cost_basis} displayType={'text'} thousandSeparator={true} prefix={'$'} decimalScale={2} fixedDecimalScale={true} /></TableCell>
                            </TableRow>
                        ))}
                        <TableRow>
                            <TableCell className={classes.totalRow}>Total</TableCell>
                            <TableCell></TableCell>
                            <TableCell></TableCell>
                            <TableCell></TableCell>
                            <TableCell className={classes.totalRow}><NumberFormat value={props.total_value} displayType={'text'} thousandSeparator={true} prefix={'$'} decimalScale={2} fixedDecimalScale={true} /></TableCell>
                            <TableCell className={classes.totalRow}><NumberFormat value={props.total_cost_basis} displayType={'text'} thousandSeparator={true} prefix={'$'} decimalScale={2} fixedDecimalScale={true} /></TableCell>
                        </TableRow>
                    </TableBody>
                </Table>
            </Paper>
        </React.Fragment>
            
        }
      </div>
  )
}

const mapStateToProps = (state, props) => {
    const {account_id} = props;


    if (!state.accounts[account_id] || !state.accounts[account_id].account_holdings) {
        return {
            total_cost_basis: 0,
            total_value: 0,
            account_holdings: [],
        }
    }

    const total_cost_basis = state.accounts[account_id].account_holdings.reduce((acc, holding) => acc + holding.total_cost_basis, 0);
    const total_value = state.accounts[account_id].account_holdings.reduce((acc, holding) => acc + holding.value, 0);
  return {
    total_cost_basis: total_cost_basis,
    total_value: total_value,
    account_holdings: state.accounts[account_id].account_holdings,
  }
}

export default connect(mapStateToProps)(withStyles(styles)(AccountHoldings));